import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography, IconButton, Box, Grid, MenuItem, CircularProgress } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikTextField from "../../../../../commons/formik/formikTextField";
import FormikSelect from "../../../../../commons/formik/formikSelect";

const validationSchema = Yup.object().shape({
  idMotivo: Yup.number().required("El motivo es obligatorio"),
  observaciones: Yup.string().required("Las observaciones son obligatorias"),
});

const RechazarDialogPT = ({ open, handleClose, tramo, motivosRechazo, handleSubmit }) => {
  if (!tramo) return null;

  return (
    <Dialog open={open} onClose={handleClose} maxWidth="md" fullWidth>
      <DialogTitle sx={{ backgroundColor: "#5b9bf5", color: "#fff", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        <Typography>RECHAZAR TRASLADO {tramo.nroTraslado}</Typography>
        <IconButton onClick={handleClose} sx={{ color: "#fff" }} size="small"><CloseIcon /></IconButton>
      </DialogTitle>

      <Formik
        initialValues={{
          idMotivo: "",
          observaciones: ""
        }}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ isSubmitting }) => (
          <Form>
            <DialogContent dividers>

              <Grid container spacing={2} sx={{ mb: 3 }}>
                <Grid item xs={12} sm={3}>
                  <Typography variant="body2" color="textSecondary">Trabajador</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Typography variant="body2">{tramo.trabajador}  DNI {tramo.documentoTrabajador}</Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Typography variant="body2" color="textSecondary">Turno</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Typography variant="body2">{tramo.fechaHoraTraslado && new Date(tramo.fechaHoraTraslado).toLocaleString()}</Typography>
                </Grid>
                <Grid item xs={12} sm={3}>
                  <Typography variant="body2" color="textSecondary">Recorrido</Typography>
                </Grid>
                <Grid item xs={12} sm={9}>
                  <Typography variant="body2">{tramo.calleOrigen} {tramo.localidadOrigen} &rarr; {tramo.calleDestino} {tramo.localidadDestino}</Typography>
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormikSelect
                    name="idMotivo"
                    label="Motivo *"
                    variant="outlined"
                    fullWidth
                  >
                    <MenuItem value="">Seleccionar...</MenuItem>
                    {motivosRechazo.map((motivo) => (
                      <MenuItem key={motivo.idMotivo} value={motivo.idMotivo}>
                        {motivo.descripcion}
                      </MenuItem>
                    ))}
                  </FormikSelect>
                </Grid>
                <Grid item xs={12}>
                  <FormikTextField
                    name="observaciones"
                    label="Observaciones *"
                    multiline
                    rows={4}
                    variant="outlined"
                    fullWidth
                  />
                </Grid>
              </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2 }}>
              <Button onClick={handleClose} color="primary" disabled={isSubmitting}>VOLVER</Button>
              <Button type="submit" variant="contained" color="error" disabled={isSubmitting}>
                {isSubmitting ? <CircularProgress size={24} color="inherit" /> : "CONFIRMAR RECHAZO"}
              </Button>
            </DialogActions>
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default RechazarDialogPT;
